/* eslint-disable max-len */
export default {
    form: {
        title: 'Complete the form and download the ebook',
        placeholder: {
            name: 'Name',
            surname: 'Surname',
            email: 'Your corporate email',
            company: 'Company'
        },
        label: {
            checkbox: 'The data are administered by Sagiton Sp.z o.o., have been provided voluntarily and will be processed by the administrator in accordance with the provisions of the Act of 29 August 1997r. about the protection of personal data (Journal of Laws of 2002, No. 101, item 926, as amended) for marketing purposes, sale of products and services Sagiton Sp.z o.o. I have been informed of the right of access to the content of their data, their correcting and the right to lodge objections to their processing at any time.',
            checkbox2: 'I agree to receive from Sagiton Sp.z o.o. commercial information by email.',
            button: 'Sign Up',
            refresh: 'Refresh'
        }
    },
    footer: {
        title: 'Are you interested in a comprehensive solution<br/> for your data security?',
        button: 'Find out our offer'
    },
    subscribed: {
        text: 'Thank you for registering for the webinar. For more info please check your email inbox.'
    },
    list: [{
        slug: 'can-i-really-secure-my-digital-assets-from-cybercriminals',
        header: {
            title: 'Subscribe to Lemlock webinar Today',
            subtitle: 'Can I really secure my digital assets from cybercriminals?',
            date: 'Data: 23rd of April 14:00 CEST'
        },
        content: {
            title: 'During the webinar you will find out:',
            list: [
                'what the threats are and who can become cybercriminals’ target',
                'what zero/one day vulnerabilities are',
                'how to decrease the risk of infiltration',
                'why cybersecurity is a continuous process'
            ],
            bottom_text: 'The webinar will be conducted by <a href="https://www.lemlock.com" target="_blank">Lemlock</a> security expert Bartłomiej Balcerek'
        }
    }, {
        slug: 'how-to-make-my-marketing-compliant-with-gdpr',
        header: {
            title: 'Subscribe to Lemlock webinar Today',
            subtitle: 'How to make my marketing compliant with GDPR?',
            date: 'Date: 12th of April 14:00 CEST'
        },
        content: {
            title: 'In the webinar you will find out:',
            list: [
                'how to conduct the profiling process compatible with GDPR',
                'what the consent to the processing of personal data should look like',
                'how to manage obtained consents',
                'how the marketing department can protect the information',
                'about the five principles of cooperation between marketing and security'
            ],
            bottom_text: 'The webinar will be conducted by <a href="https://www.lemlock.com" target="_blank">Lemlock</a> security experts Jarosław Greser and Marcin Michalski (Marketing Technology)'
        }
    }, {
        slug: 'i-was-hacked-what-should-i-do',
        header: {
            title: 'Subscribe to Lemlock webinar Today',
            subtitle: 'I was hacked … What should I do?',
            date: 'Date: 24th of March 14:00 CET'
        },
        content: {
            title: 'During the webinar you will learn about:',
            list: [
                'why most companies, if they even realize that they have been attacked, find out about the attack long time after it',
                'what technical procedures need to be conducted by your organization to properly address post-breach incidents',
                'what your legal obligations are',
                'what the consequences are when you neglect cybersecurity and data privacy aspects',
                'what you can do to prevent such incidents from happening'
            ],
            bottom_text: 'The webinar will be conducted by <a href="https://www.lemlock.com" target="_blank">Lemlock</a> security experts Bartłomiej Balcerek and Jarosław Greser'
        }
    }, {
        slug: 'live-hacking-experience-attacks-and-increase-your-awareness',
        header: {
            title: 'Subscribe to Lemlock webinar Today',
            subtitle: 'Live Hacking - Experience attacks and increase your awareness',
            date: 'Date: 14th of March 14:00 CET'
        },
        content: {
            title: 'In the webinar you will find out:',
            list: [
                'what the threats may be and who can become cybercriminals’ target',
                'in live examples, how hacker can attack you and your organization digital assets',
                'how your digital assets can be used for e.g. stealing money, taking control over your users’ computers or infiltrating your admin accounts',
                'what you can do to prevent it from happening'
            ],
            bottom_text: 'The webinar will be conducted by <a href="https://www.lemlock.com" target="_blank">Lemlock</a> security expert Bartłomiej Balcerek'
        }
    }, {
        slug: 'what-to-do-if-i-want-to-create-gdpr-compliant-apps',
        header: {
            title: 'Subscribe to Lemlock webinar Today',
            subtitle: 'What to do if I want to create GDPR compliant apps?',
            date: 'Date: 31st of March 14:00 CEST'
        },
        content: {
            title: 'In the webinar you will find out:',
            list: [
                'what GDPR is and what provisions it mandates for organizations',
                'what usually is neglected or overlooked when you think about creating an app',
                'how to prepare your systems and applications for GDPR compliance in design phase',
                'how to adapt already developed systems and applications to the requirements of the GDPR'
            ],
            bottom_text: 'The webinar will be conducted by <a href="https://www.lemlock.com" target="_blank">Lemlock</a> security experts Jarosław Greser and Grzegorz Mąkosa (System Architect)'
        }
    }, {
        slug: 'what-to-do-if-i-want-to-create-secured-it-systems-and-apps',
        header: {
            title: 'Subscribe to Lemlock webinar Today',
            subtitle: 'What to do if I want to create secured IT systems and apps?',
            date: 'Date: 5th of April 14:00 CEST'
        },
        content: {
            title: 'During the webinar you will find out:',
            list: [
                'what the threats are and who can become cybercriminals’ target',
                'what is Security by Design and Security by Default and why you should keep that in mind when thinking of creating an application',
                'how to increase the security of applications without decreasing its usability',
                'how to make your data useless for those who will try to steal them'
            ],
            bottom_text: 'The webinar will be conducted by <a href="https://www.lemlock.com" target="_blank">Lemlock</a> security experts Jarosław Greser and Grzegorz Mąkosa (System Architect)'
        }
    }]
};



// WEBPACK FOOTER //
// ./src/i18n/en/webinar.js